import { createFileRoute } from '@tanstack/react-router'
import PortaisPage from '@/pages/portais/portais-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

// Rota index para /dashboard/$dashboardId/portais
// Renderizada quando acessar diretamente /dashboard/$dashboardId/portais
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/portais/',
)({
  component: function PortaisIndexRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.PORTAIS} dashboardId={dashboardId}>
        <PortaisPage />
      </RequireModule>
    )
  },
})
